<script setup lang="ts">
const currentArticle = inject(keys.currentArticle);
</script>

<template>
  <section
    v-if="currentArticle"
    class="w-full bg-(--background) py-16 text-(--foreground) sm:py-24"
    :class="currentArticle.colorTheme"
  >
    <UArticleContainer class="relative flex flex-col gap-8">
      <UiArticlesTheme prefix="Tema: " />
      <UiArticlesTitle class="text-4xl sm:text-7xl" />
      <div class="pb-8 text-xl font-semibold sm:text-3xl" v-html="currentArticle.intro" />
      <UiArticlesByline class="flex gap-4 font-headline text-xl sm:absolute sm:-bottom-8 sm:left-[-7.3rem] sm:items-center sm:gap-8">
        <IconsGraphicsStarTag
          class="hidden sm:flex"
          :fill="currentArticle.colorTheme"
          aria-hidden="true"
        />
      </UiArticlesByline>
    </UArticleContainer>
  </section>
</template>
